import React, { useEffect, useState } from 'react';
import {
    UncontrolledCollapse,
    Button,
    Card,
    CardBody,
    Row,
    Col,
    Input,
    UncontrolledTooltip
} from "reactstrap";

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaInfoCircle } from "react-icons/fa";
import { useClipboard } from 'use-clipboard-copy';
import { FaCopy } from "react-icons/fa";

import "../../../assets/scss/Dashboards/dashboardHE.scss"
import { ObtenerUsuariosPro } from './FunctionDashboard';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';

const USERPI: string = process.env.REACT_APP_PI_USER || '';
const PWPI: string = process.env.REACT_APP_PI_PW || '';

// export const UsuarioPro:
//     Array<string> = ['edelgado@espol.edu.ec', 'dade@espol.edu.ec', 'mbaez@espol.edu.ec', 'cvaca@espol.edu.ec', 'ypino@espol.edu.ec', 'pcrow@espol.edu.ec',
//         'fmalo@espol.edu.ec', 'nmunoz@espol.edu.ec', 'aboero@espol.edu.ec', 'dtagle@espol.edu.ec', 'vtapia@espol.edu.ec', 'pvaldi@espol.edu.ec',
//         'mlnath@espol.edu.ec', 'hapolo@espol.edu.ec', 'avaras@espol.edu.ec', 'hplaza@espol.edu.ec', 'jperal@espol.edu.ec', 'gcuzco@espol.edu.ec',
//         'jcedeno@espol.edu.ec', 'mflopez@espol.edu.ec', 'eaterac@espol.edu.ec', 'jnietow@espol.edu.ec', 'aramire@espol.edu.ec', 'aalvare@espol.edu.ec',
//         'psantos@espol.edu.ec', 'hxmoran@espol.edu.ec', 'fjacome@espol.edu.ec', 'dtinoco@espol.edu.ec', 'imartin@espol.edu.ec', 'vguzman@espol.edu.ec',
//         'fbertuc@espol.edu.ec', 'eialava@espol.edu.ec', 'ldender@espol.edu.ec', 'ogarces@espol.edu.ec', 'acollag@espol.edu.ec', 'sguarta@espol.edu.ec',
//         'ocoloma@espol.edu.ec', 'mmendoza@espol.edu.ec', 'gbaqueri@espol.edu.ec', 'plromero@espol.edu.ec', 'achanaba@espol.edu.ec', 'lrodrigu@espol.edu.ec',
//         'mjimenez@espol.edu.ec', 'mpastuiz@espol.edu.ec', 'esanclem@espol.edu.ec', 'arivasfe@espol.edu.ec', 'pmpacton@espol.edu.ec', 'amoncayo@espol.edu.ec',
//         'jecaniza@espol.edu.ec', 'kfcaiced@espol.edu.ec', 'jaaviles@espol.edu.ec', 'jesamene@espol.edu.ec', 'lmoreira@espol.edu.ec', 'mafercal@espol.edu.ec',
//         'dagallar@espol.edu.ec', 'ecolmont@espol.edu.ec', 'aquinter@espol.edu.ec', 'pacampov@espol.edu.ec', 'mccastil@espol.edu.ec', 'bryjosal@espol.edu.ec',
//         'whurtare@espol.edu.ec', 'jcsolano@espol.edu.ec', 'marefrei@espol.edu.ec', 'rdurango@espol.edu.ec', 'cfalcone@espol.edu.ec', 'josecuev@espol.edu.ec',
//         'fearvaca@espol.edu.ec', 'vejaojed@espol.edu.ec', 'jmrodrig@espol.edu.ec', 'gandrade@espol.edu.ec', 'ajmarque@espol.edu.ec', 'jfaytong@espol.edu.ec',
//         'jwespino@espol.edu.ec', 'vrguadal@espol.edu.ec', 'gabanmur@espol.edu.ec', 'atoapant@espol.edu.ec', 'adortega@espol.edu.ec', 'jraizpru@espol.edu.ec',
//         'judagala@espol.edu.ec', 'farguell@espol.edu.ec', 'meromero@espol.edu.ec', 'slopez@espol.edu.ec', 'fveloz@espol.edu.ec', 'davaca@espol.edu.ec',
//         'dgnoboa@espol.edu.ec', 'rmacias@espol.edu.ec', 'aagarci@espol.edu.ec', 'asreyes@espol.edu.ec', 'gonvaca@espol.edu.ec', 'mongelo@espol.edu.ec',
//         'omartin@espol.edu.ec', 'gvilela@espol.edu.ec', 'sloaiza@espol.edu.ec', 'vosorio@espol.edu.ec', 'bperero@espol.edu.ec', 'cparedes@espol.edu.ec',
//         'jbermude@espol.edu.ec', 'jofersan@espol.edu.ec', 'ejgarcia@espol.edu.ec', 'jomabust@espol.edu.ec', 'monsalve@espol.edu.ec', 'enjimene@espol.edu.ec',
//         'gmcarvaj@espol.edu.ec', 'amtorres@espol.edu.ec', 'famoreir@espol.edu.ec', 'nadmflor@espol.edu.ec', 'caalronq@espol.edu.ec', 'lmarchan@espol.edu.ec',
//         'nvasquez@espol.edu.ec', 'nquijano@espol.edu.ec', 'jorollig@espol.edu.ec', 'pestolay@espol.edu.ec', 'jecordov@espol.edu.ec', 'jfmoncay@espol.edu.ec',
//         'jlasenci@espol.edu.ec', 'jjcordov@espol.edu.ec', 'purdiale@espol.edu.ec', 'noeelavi@espol.edu.ec', 'angdabaq@espol.edu.ec', 'josasanc@espol.edu.ec',
//         'mabrione@espol.edu.ec'];

// function getUsuariosProPBI(): Array<string> {
//     const pros: Array<string> = UsuarioPro;
//     return pros;
// }

interface ExpansiblePanelPIProps {
    title: string;
    nombres: string;
    apellidos: string;
    usuario: string;
}

export const ExpansiblePanelPI: React.FC<ExpansiblePanelPIProps> = ({ title, nombres, apellidos, usuario }) => {
    const [listPros, setListPros] = useState<string[]>();
    const [Listaobtenida, setListaobtenida] = useState<boolean>(false);
    const [cuentaPro, setCuentaPro] = useState<boolean>(false);

    const clipboardUser = useClipboard({ copiedTimeout: 2000 });
    const clipboardPass = useClipboard({ copiedTimeout: 2000 });

    useEffect(() => {
        getUsuariosProPBI();
    }, []);

    useEffect(() => {
        const correo = usuario + "@espol.edu.ec";
        if(listPros){
            setCuentaPro(listPros.includes(correo));
        }
    }, [Listaobtenida]);

    async function getUsuariosProPBI() {
        const respuestaUsuarios = await ObtenerUsuariosPro();
        if (respuestaUsuarios.status == 200 && respuestaUsuarios.dataResponse) {
            var usuariosLista = respuestaUsuarios.dataResponse;
            setListPros(usuariosLista);
            setListaobtenida(true);
        }
        else {
            showAlert(respuestaUsuarios.errorMessage ?? "", false);
        }
    }
    
    return (
        <div className="w-100">
            <div className="d-flex align-items-center mb-2">
                <Button color="primary" id="toggleAccordion">
                    <FaInfoCircle className="me-2" /> {title}
                </Button>
            </div>
            <UncontrolledCollapse toggler="#toggleAccordion">
                {cuentaPro ? (
                    <Card className="p-3 mt-2">
                        <CardBody>
                            <h6>¡Hola {nombres} {apellidos}!</h6>
                            <p>
                                Usted posee una cuenta Pro de Power BI, puedes continuar y acceder a todas las funciones del Dashboard con tu cuenta de ESPOL.
                            </p>
                        </CardBody>
                    </Card>
                ) : (
                    <Card className="p-3 mt-2">
                        <CardBody>
                            <h6>¡Hola {nombres} {apellidos}!</h6>
                            <p>
                                Usted <strong>NO</strong> posee una cuenta Pro de Power BI.
                            </p>
                            <p>
                                Usted debe <strong>cerrar sesión</strong> en la cuenta que ya tenga iniciada para evitar inconvenientes y utilizar las credenciales facilitadas a continuación:
                            </p>
                            <Row className="align-items-center">
                                <Col md={5} >
                                    <label>Usuario</label>
                                    <Input type="text" value={USERPI} readOnly innerRef={clipboardUser.target} />
                                </Col>
                                <Col md={1} className="colContainerClipboard ">
                                    <Button className="buttonClipBoard" id="copyUser" onClick={clipboardUser.copy}>
                                        <FaCopy style={{height: '20px', width: '20px'}} />
                                    </Button>
                                    <UncontrolledTooltip target="copyUser">
                                        {clipboardUser.copied ? "Copiado" : "Copiar al portapapeles"}
                                    </UncontrolledTooltip>
                                </Col>
                                <Col md={5} >
                                    <label>Contraseña</label>
                                    <Input type="password" value={PWPI} readOnly innerRef={clipboardPass.target} />
                                </Col>
                                <Col md={1} className="colContainerClipboard">
                                    <Button className="buttonClipBoard" id="copyPass" onClick={clipboardPass.copy}>
                                        <FaCopy style={{height: '20px', width: '20px'}} />
                                    </Button>
                                    <UncontrolledTooltip target="copyPass">
                                        {clipboardPass.copied ? "Copiado" : "Copiar al portapapeles"}
                                    </UncontrolledTooltip>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                )}
            </UncontrolledCollapse>
        </div>
    );
};